module.exports = __webpack_public_path__ + "static/media/foodBag3.a7b78205.jpg";